import { NavigationStructure } from '@/components/navigation/common-navigation'

export const TransformersNavigationConfiguration: NavigationStructure = [
    {
        titleKey: 'navigation.tabs.portfolioOverview',
        destinationRouteName: 'Transformers_PortfolioOverview',
        matchRouteNames: ['Transformers_PortfolioOverview'],
    },
    {
        titleKey: 'navigation.tabs.componentStatus',
        destinationRouteName: 'Transformers_ConditionStatus',
        matchRouteNames: ['Transformers_ConditionStatus', 'Reports_View_Condition'],
    },
    {
        titleKey: 'navigation.tabs.portfolioTrends',
        destinationRouteName: 'Transformers_PortfolioTrends',
        matchRouteNames: ['Transformers_PortfolioTrends'],
    },
]
